import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Container, PillButton } from '../home/ui';

const navLinks = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About' },
  { path: '/services', label: 'Services' },
  { path: '/blog', label: 'Blog' },
  { path: '/contact', label: 'Contact' },
];

// A section stays highlighted on its sub-pages too (e.g. Blog on /blog/my-post).
export const isActivePath = (pathname, path) =>
  path === '/' ? pathname === '/' : pathname === path || pathname.startsWith(`${path}/`);

export const Logo = ({ light = false, to = '/', label = 'Binud Panging home' }) => (
  <Link to={to} className="flex items-center gap-2.5" aria-label={label}>
    <img
      src={process.env.PUBLIC_URL + '/logo-on-dark.png'}
      alt=""
      className="w-9 h-9"
    />
    <span className={`text-lg font-medium tracking-[-0.02em] ${light ? 'text-white' : 'text-[#111]'}`}>Binud</span>
  </Link>
);

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#e9ecf2]/95 backdrop-blur-md shadow-[0_1px_0_rgba(17,24,58,0.06)]' : 'bg-transparent'
      }`}
    >
      <Container className="h-[76px] flex items-center justify-between">
        <div className="flex items-center gap-10">
          <Logo />
          <nav className="hidden md:flex items-center gap-7">
            {navLinks.map(({ path, label }) => (
              <Link
                key={path}
                to={path}
                className={`text-sm transition-colors ${
                  isActivePath(pathname, path) ? 'text-[#111] font-medium' : 'text-[#111]/60 hover:text-[#111]'
                }`}
              >
                {label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-2">
          <PillButton to="/contact" size="sm" className="hidden sm:inline-flex">
            Get In Touch
          </PillButton>
          <button
            type="button"
            onClick={() => setIsOpen((o) => !o)}
            aria-label={isOpen ? 'Close menu' : 'Open menu'}
            className="md:hidden w-10 h-10 rounded-full bg-[#111] text-white flex items-center justify-center"
          >
            {isOpen ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
          </button>
        </div>
      </Container>

      {isOpen && (
        <div className="md:hidden mx-5 mb-4 rounded-2xl bg-[#f4f6fa] p-2 shadow-[0_20px_50px_rgba(17,24,58,0.15)]">
          {navLinks.map(({ path, label }) => (
            <Link
              key={path}
              to={path}
              className={`block px-4 py-3 rounded-xl text-sm ${
                isActivePath(pathname, path) ? 'bg-[#111] text-white' : 'text-[#111] hover:bg-black/5'
              }`}
            >
              {label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};

export default Navbar;
